import { defineAsyncComponent } from 'vue'
export default {
  "clean-dark-green": defineAsyncComponent(() => import("/opt/build/repo/website/main/layouts/clean-dark-green.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/website/main/layouts/default.vue").then(m => m.default || m)),
  events: defineAsyncComponent(() => import("/opt/build/repo/website/main/layouts/events.vue").then(m => m.default || m)),
  manuals: defineAsyncComponent(() => import("/opt/build/repo/website/main/layouts/manuals.vue").then(m => m.default || m))
}